import { addDays, startOfDay, subDays } from 'date-fns';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL } from '@sorare/core/src/atoms/typography';
import { ListWithDetailLayout } from '@sorare/core/src/components/layout/ListWithDetailLayout';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { MLB_SCOUTING_CENTER_SCORES } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { fantasy, scoutingCenter } from '@sorare/core/src/lib/glossary';

import { DatePicker } from '@sorare/gameplay/src/components/scoutingCenter/gameCenter/DatePicker';

const ListWrapper = styled(Vertical)`
  padding: var(--double-unit) 0;
`;

const ScoutingCenterGamesLayout = () => {
  const {
    flags: { useNewMlbGameCenter = false },
  } = useFeatureFlags();
  const today = startOfDay(new Date());
  const [selectedDate, setSelectedDate] = useState<string>(today.toISOString());

  // Show today and +-10 days
  // Need to use WithSlug format to use DateOrFixturePicker
  const tenDaysAgo = subDays(startOfDay(new Date()), 10);
  const dates = Array.from({ length: 21 }, (_, i) => ({
    slug: addDays(tenDaysAgo, i).toISOString(),
  })).reverse();

  if (!useNewMlbGameCenter) {
    return <Navigate to={MLB_SCOUTING_CENTER_SCORES} />;
  }

  return (
    <>
      <PageHeader text={scoutingCenter.scout} disableBackBrowser />
      <ListWithDetailLayout noRightPanelPadding>
        <ListWrapper gap={3}>
          <BrandL>
            <FormattedMessage {...fantasy.gameCenter} />
          </BrandL>
          <DatePicker
            dates={dates}
            value={{ slug: selectedDate }}
            onChange={date => setSelectedDate(date.slug)}
          />
        </ListWrapper>
      </ListWithDetailLayout>
    </>
  );
};

export default ScoutingCenterGamesLayout;
